import { useEffect, useRef, useState } from 'react';
import { ImageContainer } from '../../../../constants/ImagesConstants';
const { USERIMAGE } = ImageContainer;
import SalonDetailsEdit from '../../../../components/Model/SalonDetailsEdit';
import SalonOwnerDetailsEdit from '../../../../components/Model/SalonOwnerDetailsEdit';
import { useDispatch, useSelector } from 'react-redux';
import { MyProfileDetailAction, SalonDetailAction } from '../../../../redux/Action/MyProfileAction';
import Spinner from '../../../../components/Spinner';
import { FormattedMessage } from 'react-intl';
import { sidebarOpen } from '../../../../utils/Helper';

// import Model from '../../../../components/Model/Model';

const MyProfile = () => {
    const dispatch = useDispatch<any>();
    const profile_data = useSelector((state: any) => state.GetProfileState);
    const my_profile_data = useSelector((state: any) => state.MyProfileDetailState);
    const salon_detail = useSelector((state: any) => state.SalonDetailState);
    const [profileData, setProfileData]: any = useState([])
    const [ownerDetailStatus, setOwnerDetailStatus] = useState(false)
    // const [ownerDetailStatus, setOwnerDetailStatus] = useState(false)

    const containerRef: any = useRef(null);

    const salon_owner = useSelector((state: any) => state.MyProfileUpdateState)
    const salon_state = useSelector((state: any) => state.SalonUpdateState);


    const handleSalonDetail = () => {
        dispatch(SalonDetailAction({ detail_id: profile_data?.data?.data?.id }))

    }

    useEffect(() => {
        dispatch(MyProfileDetailAction({ detail_id: profile_data?.data?.data?.id }))
    }, [])


    useEffect(() => {
        if (salon_owner?.status || salon_state?.status) {
            dispatch(MyProfileDetailAction({ detail_id: profile_data?.data?.data?.id }))
        }
    }, [salon_owner, salon_state])


    useEffect(() => {
        if (my_profile_data?.status) {
            setProfileData(my_profile_data?.data?.data?.detail)
        }
    }, [my_profile_data]);

    useEffect(() => {
        return () => {
            dispatch(MyProfileDetailAction("RESET"))
            dispatch(SalonDetailAction("RESET"))
            $('.modal-backdrop').remove();
        }
    }, [])

    

    const getDirections = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const { latitude, longitude } = position.coords;
                const destination = encodeURIComponent(my_profile_data?.data?.data?.detail?.location); // Replace 'jaipur' with your destination address

                const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
                // const directionsUrl = `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${destination}`;

                window.open(directionsUrl, '_blank');
            }, (error) => {
                console.error('Error getting the current position:', error);
                alert('Could not get your current location.');
            });
        } else {
            alert('Geolocation is not supported by this browser.');
        }
    };


    return (
        <>
            <div className='col-lg-9 '>
                {my_profile_data?.loading ? <Spinner /> : null}
                <div className='dashboard bg-white'>
                    <div className='dashboardTop'>
                        <h2><button type='button' className='btn mobileMenu p-1 d-lg-none' onClick={() => { sidebarOpen() }} ><span className="icon-menu-right"></span></button> <FormattedMessage id="my_profile" /></h2>
                    </div>
                    <div className='aboutset aboutSalon'>
                        <h2><FormattedMessage id="about_salon" /></h2>
                        <div className='row'>
                            <div className='col-sm-3 col-md-3 col-xl-4'>
                                <figure className='UserProfile'><img src={profileData?.buisness_images?.[0]?.file_path ? profileData?.buisness_images?.[0]?.file_path : ""}
                                    onError={(e: any) => e.target.src = ImageContainer?.profImg}
                                // onError={(e: any) => e.target.src = ImageContainer?.AboutImg}


                                /></figure>
                            </div>
                            <div className='col-sm-9 col-md-9 col-xl-8'>
                                <div className='salonInfo'>
                                    <h6>{profileData?.salon_name ? profileData?.salon_name : "N/A"}</h6>

                                    {/* <div className='rating'>
                                        <div className='star'>
                                            <span className="icon-star-fill"></span>
                                            <span className="icon-star-fill"></span>
                                            <span className="icon-star-fill"></span>
                                            <span className="icon-star-fill"></span>
                                            <span className="icon-star"></span>
                                        </div>
                                        <div className='reviewCount'>{profileData?.avg_rating}.0 <span>(622 Reviews)</span></div>
                                    </div> */}

                                    <div className='rating'>
                                        <div className='star'>
                                            {Array.from({ length: 5 }, (_, index) => (
                                                <span
                                                    key={index}
                                                    className={index < Math.floor(profileData?.avg_rating) ? 'icon-star-fill' : 'icon-star'}
                                                ></span>
                                            ))}
                                        </div>
                                        <div className='reviewCount'>
                                            {profileData?.avg_rating?.toFixed(1)} <span>({profileData?.review_count ? profileData?.review_count : '0'} Reviews)</span>
                                        </div>
                                    </div>


                                    <div className='aboutContact'>
                                        <span><i className="icon-call"></i>{(profileData?.phone_country_code ? profileData?.phone_country_code : "") + " " + (profileData?.phone_number ? profileData?.phone_number : "N/A")}</span>
                                        <span><i className="icon-email"></i>{profileData?.email ? profileData?.email : "N/A"}</span>
                                    </div>
                                    <div className='aboutLocation'>
                                        <span><i className="icon-location"></i> {(profileData?.location ? profileData?.location : "N/A") + ", " + (profileData?.country ? profileData?.country : "")}</span>
                                        <button type='button' className='btn btn-sm-outline rounded-pill ms-3' onClick={getDirections}>Directions</button>
                                    </div>
                                    <div className='solanPrice'>€{profileData?.min_price ? profileData?.min_price : ""} - €{profileData?.max_price ? profileData?.max_price : ""} </div>
                                    <button type='button' className='btn editBTN btnOUtlinePrimary d-none d-md-block' data-bs-toggle="modal" data-bs-target="#salondetailsEnd" onClick={handleSalonDetail}><span className="icon-edit"></span> <FormattedMessage id="edit_salon_detail" /></button>
                                    {/* <button type='button' data-bs-toggle="modal" data-bs-target="#salonOwnerdetailsEnd" className='btn editBTN btnOUtlinePrimary d-none d-md-block'><span className="icon-edit"></span> Edit Salon Details</button> */}
                                </div>
                            </div>
                        </div>
                        <div className='S_description'>{profileData?.description ? profileData?.description + "." : "N/A"}</div>
                        {/* <button type='button' data-bs-toggle="modal" data-bs-target="#salonOwnerdetailsEnd" className='btn editBTN btnOUtlinePrimary my-4 d-md-none'><span className="icon-edit"></span> Edit Owner Details</button> */}
                    </div>
                    <div className='aboutset'>
                        <h2><FormattedMessage id="about_salon_owner" /></h2>
                        <div className='ownerPhoto'>
                            <figure><img src={profileData?.profile_pic ? profileData?.profile_pic : USERIMAGE} onError={(e: any) => e.target.src = USERIMAGE} /></figure>
                            <div className='ownerDeta'>
                                <p className='ownerName'>{profileData?.owner_name ? profileData?.owner_name : ""}</p>
                                <p className='ownerYears'>{profileData?.owner_experience} years Experience</p>
                                <div className='profdoc'>
                                    <figure><img src={profileData?.owner_image?.file_path ? profileData?.owner_image?.file_path : USERIMAGE}

                                        onError={(e: any) => e.target.src = ImageContainer?.ProfileDetailIconImage}
                                    /></figure>
                                    <p>Proof of <br /> Salon Owner</p>
                                </div>
                            </div>
                            {/* <button type='button' className='btn editBTN btnOUtlinePrimary my-3 d-md-none' data-bs-toggle="modal" data-bs-target="#salondetailsEnd"><span className="icon-edit"></span> Edit Owner Details</button> */}
                            <button type='button' data-bs-toggle="modal" data-bs-target="#salonOwnerdetailsEnd" className='btn editBTN btnOUtlinePrimary ms-md-auto d-none d-md-block'><span className="icon-edit"></span> <FormattedMessage id="edit_owner_detail" /></button>
                        </div>
                    </div>

                </div>
            </div>
            <SalonDetailsEdit profileData={salon_detail ? salon_detail : ""} setOwnerDetailStatus={setOwnerDetailStatus} />
            <SalonOwnerDetailsEdit profile_data={my_profile_data ? my_profile_data : ""} setOwnerDetailStatus={setOwnerDetailStatus} />
        </>

    )
}

export default MyProfile
